export const UPLOAD_DOCUMENT_REQUEST = 'UPLOAD_DOCUMENT_REQUEST';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_FAILURE = 'UPLOAD_DOCUMENT_FAILURE';

export const CLEAR_DOCUMENT_ERRORS = 'CLEAR_DOCUMENT_ERRORS';
export const CLEAR_DOCUMENT_SUCCESS = 'CLEAR_DOCUMENT_SUCCESS';